// The line right above a flat content list (plan R6 §2.1): the "Saving order…"
// caption while a move saves, the sentence of a failed move, and the hint of a
// mixed view where the order cannot be changed.
import { Alert, Stack, Typography } from '@mui/material';
import { SAVING_ORDER_TEXT } from './reorderModel';

type Props = {
  error: string | null;
  saving?: boolean;
  onClose?: VoidFunction;
  // e.g. "Pick a section to change its order".
  hint?: string | null;
};

export default function OrderErrorAlert({ error, saving = false, onClose, hint }: Props) {
  if (!error && !saving && !hint) return null;
  return (
    <Stack spacing={1} sx={{ mb: 2 }}>
      {error && (
        <Alert severity="error" onClose={onClose} role="alert">
          {error}
        </Alert>
      )}
      {saving && (
        <Typography variant="caption" color="text.secondary" role="status">
          {SAVING_ORDER_TEXT}
        </Typography>
      )}
      {hint && !saving && (
        <Typography variant="caption" color="text.secondary">
          {hint}
        </Typography>
      )}
    </Stack>
  );
}
